<template>
  <div>
    <CommonHeader />
    <section v-if="info" class="tw-container tw-mx-auto wow fadeInUp" data-wow-delay="0.1s">
      <div class="tw-flex tw-justify-center tw-py-7 sm:tw-py-10 lg:tw-py-16 xl:tw-py-24 tw-overflow-hidden">
        <SvgoMenuHeaderLogo class="tw-w-[150px] sm:tw-w-[180px] lg:tw-w-[255px] xl:tw-w-[375px]" />
        <SvgoCommonIconX class="tw-mx-3 sm:tw-mx-5 lg:tw-mx-8 xl:tw-mx-10 tw-w-5 sm:tw-w-6 lg:tw-w-7 xl:tw-w-12" />
        <NuxtImg :alt="info.name" :src="info.logo" class="tw-w-[100px] sm:tw-w-[120px] lg:tw-w-[150px] xl:tw-w-[250px]" />
      </div>
      <section class="bg -tw-mx-5">
        <section
          class="tw-py-14 sm:tw-py-16 lg:tw-py-18 xl:tw-py-20 tw-flex tw-flex-col tw-gap-14 sm:tw-gap-16 lg:tw-gap-18 xl:tw-gap-20 tw-bg-white tw-relative tw-rounded-[20px] lg:tw-rounded-2xl xl:tw-rounded-3xl tw-px-5"
        >
          <section class="tw-px-0 sm:tw-px-5 lg:tw-px-10 xl:tw-px-14">
            <div class="tw-grid tw-grid-cols-12 tw-gap-y-8">
              <div class="tw-col-span-12">
                <h2 class="tw-text-3xl xl:tw-text-5xl tw-font-bold xl:tw-font-black tw-text-center wow !tw-leading-tight">{{
                  $t(`${info.key}.title`)
                }}</h2>
                <p
                  class="tw-mt-5 lg:tw-mt-6 xl:tw-mt-7 tw-text-base sm:tw-text-lg lg:tw-text-xl tw-text-center wow fadeInUp"
                  data-wow-delay="0.4s"
                  >{{ $t(`${info.key}.subTitle`) }}</p
                >
              </div>
              <div class="tw-col-span-12 lg:tw-order-last -tw-mr-5">
                <div class="tw-flex tw-h-[400px] lg:tw-h-[600px] tw-justify-center tw-items-center">
                  <div class="tw-basis-0 lg:tw-basis-3/4">
                    <NuxtImg alt="case-desktop" :src="info.desktop" />
                  </div>
                  <div class="tw-basis-0 lg:tw-basis-1/4">
                    <NuxtImg alt="case-desktop" :src="info.mobile" />
                  </div>
                  <div
                    class="tw-basis-full tw-h-full lg:tw-basis-0 tw-bg-cover lg:tw-bg-contain tw-relative tw-bg-no-repeat"
                    :style="{
                      backgroundImage: `url('${info.desktop}')`,
                    }"
                  >
                    <NuxtImg alt="case-desktop" class="tw-w-[180px] tw-bottom-0 tw-absolute lg:tw-hidden" :src="info.mobile" />
                  </div>
                </div>
              </div>
              <div class="tw-col-span-12 lg:tw-col-span-7 tw-flex tw-flex-col tw-justify-center tw-items-center lg:tw-px-8">
                <h2 class="tw-text-3xl xl:tw-text-5xl tw-font-black">{{ $t('our-integration') }}</h2>
                <p class="tw-text-base sm:tw-text-lg lg:tw-text-xl tw-mt-5 lg:tw-mt-6 xl:tw-mt-7">{{
                  $t(`${info.key}.integration.title`)
                }}</p>
              </div>
              <div class="tw-col-span-12 lg:tw-col-span-5 -tw-mx-6 lg:tw-mx-0">
                <ClientOnly>
                  <Swiper
                    class="tw-h-[262px] lg:tw-h-[800px] my-swiper after:tw-hidden before:tw-hidden after:lg:tw-block before:lg:tw-block"
                    :grabCursor="true"
                    :centeredSlides="true"
                    :spaceBetween="16"
                    :loop="true"
                    :autoplay="{
                      delay: 2500,
                      disableOnInteraction: false,
                    }"
                    zoom
                    :breakpoints="{
                      '0': {
                        slidesPerView: 1.2,
                        direction: 'horizontal',
                      },
                      '1024': {
                        slidesPerView: 3,
                        direction: 'vertical',
                      },
                    }"
                    :modules="[Pagination, Autoplay]"
                  >
                    <SwiperSlide v-for="(item, index) in ($tm(`${info.key}.integration.list`) as any[])" :key="index">
                      <section
                        class="tw-h-full tw-px-5 tw-py-5 lg:tw-px-10 lg:tw-py-10 tw-rounded-2xl"
                        :style="`background-color: ${info.primaryColors.color01};`"
                      >
                        <div class="tw-flex tw-flex-col tw-gap-4 xl:tw-gap-2">
                          <h6 :style="`color: ${info.primaryColors.color}`" class="lg:tw-text-lg tw-font-border">
                            {{ $rt(item.title) }}
                          </h6>
                          <p class="tw-text-sm xl:tw-text-base">{{ item.content }}</p>
                        </div>
                      </section>
                    </SwiperSlide>
                  </Swiper>
                </ClientOnly>
              </div>
            </div>
          </section>

          <section
            :style="`background-color: ${info.primaryColors.color}`"
            class="wow flipUp tw-px-6 sm:tw-px-8 lg:tw-px-10 xl:tw-px-14 tw-py-14 tw-rounded-2xl"
            data-wow-delay="0.2s"
          >
            <h6 class="tw-text-white tw-text-base sm:tw-text-lg lg:tw-text-xl tw-font-bold !tw-leading-loose">{{
              $t(`${info.key}.introduce.title`)
            }}</h6>
            <p class="tw-text-white tw-text-base sm:tw-text-lg lg:tw-text-xl">{{ $t(`${info.key}.introduce.subTitle`) }}</p>
          </section>
          <PartnerShipsBuildWithUs />
        </section>
      </section>
    </section>
  </div>
</template>

<script lang="ts" setup>
  import { Pagination, Autoplay } from 'swiper/modules'
  import { Swiper, SwiperSlide } from 'swiper/vue'
  import { PARTNERS_PAY } from '~/config'

  import 'swiper/css'
  import 'swiper/css/pagination'

  const route = useRoute()

  const info = ref(PARTNERS_PAY.find((item) => item.key === route.params.name))
</script>
<style scoped lang="scss">
  .my-swiper {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      z-index: 2;
      width: 100%;
      left: 0;
      top: 0;
      height: 20%;
      background-image: linear-gradient(0deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 75%);
    }

    &::after {
      content: '';
      position: absolute;
      z-index: 2;
      width: 100%;
      left: 0;
      bottom: 0;
      height: 20%;
      background-image: linear-gradient(180deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 1) 75%);
    }
  }

  .bg {
    position: relative;

    &::before {
      content: '';
      position: absolute;
      filter: blur(10px);
      border-radius: 20px;
      background-image: linear-gradient(180deg, rgba(17, 18, 36, 0.1), hsla(0, 0%, 100%, 0.5));
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }

  // .desktop {
  //   background-image: url('/res/img/cases/kucoin-desktop.png');
  //   background-repeat: no-repeat;
  //   position: relative;
  // }
</style>
